function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import path from 'ramda/src/path';
import { RIGHT_ALIGNED_HEADER_TEMPLATE } from 'invision-ui/lib/components/collections/datatable/cellTemplates/cellTemplates';
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from '../../../../../locales/keys';
import { ORDER_STATUS } from '../../../../customer/orderHistory/orderDetails/order.details.constants';
import { SERVICE_SUSPENSION_TYPES } from '../../../constants/service.constants';
import { clearServiceSuspendResumeModal, retrieveServiceSuspensionQuote, setSelectedServiceIdentifierValues } from '../../../../../reducers/actions/services.suspend.resume.modal.actions';
import { IsBillCycleOptionEnabledSelector, IsloadingServiceSuspensionQuote, ServicesSuspensionQuoteFormattedSelector } from '../../../../../reducers/selectors/services.suspend.resume.modal.selectors';
import { HasFinanceInstallmentSuspendResumeAccessSelector, HasSubscriberBillingAndNetworkSuspensionAccessSelector } from '../../../../../reducers/selectors/permissions.selectors';
import { DEVICE_FINANCE_STATUS } from 'invision-core/src/constants/status.constants';
import { BillCycleDetailsSelector } from '../../../../../reducers/selectors/customer.billcycle.selectors';
import { retrieveBillCycleDetails } from '../../../../../reducers/actions/customer.billcycle.actions';
import { CurrentCustomerBillCycleSelector } from '../../../../../reducers/selectors/customer.selectors';
var ServicesSuspendResumeController = /*#__PURE__*/function () {
  function ServicesSuspendResumeController($filter, $ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ServicesSuspendResumeController);
    Object.assign(this, {
      $filter: $filter,
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerCareKeys: CustomerCareKeys,
      DEVICE_FINANCE_STATUS: DEVICE_FINANCE_STATUS,
      doErrorsExistOnFdoForm: this.doErrorsExistOnFdoForm.bind(this),
      EMPTY_STRING: '',
      formErrorMessages: [],
      onExecutionOptionChange: this.onExecutionOptionChange.bind(this),
      onRowSelectionChanged: this.onRowSelectionChanged.bind(this),
      onSubmitForm: this.onSubmitForm.bind(this),
      onSuspensionTypeChange: this.onSuspensionTypeChange.bind(this),
      MAX_DESCR_LENGTH: 200,
      model: {
        comment: null,
        serviceIdentifiers: [],
        selectedReasonCode: null,
        deviceFinancesDictionary: {},
        specifiedDate: null,
        suspensionType: null
      },
      onSubmissionPage: false,
      selectedItems: [],
      SERVICE_SUSPENSION_TYPES: SERVICE_SUSPENSION_TYPES,
      showDeviceFinancingNotApplicableLabel: this.showDeviceFinancingNotApplicableLabel.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServicesSuspendResumeController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          billCycleDetails: BillCycleDetailsSelector(store),
          currentCustomerBillCycle: CurrentCustomerBillCycleSelector(store),
          hasBillingSuspensionAccess: HasSubscriberBillingAndNetworkSuspensionAccessSelector(store),
          hasFinanceSuspendResumeAccess: HasFinanceInstallmentSuspendResumeAccessSelector(store),
          isBillCycleOptionEnabled: IsBillCycleOptionEnabledSelector(store),
          isLoadingQuote: IsloadingServiceSuspensionQuote(store),
          servicesSuspensionQuotes: ServicesSuspensionQuoteFormattedSelector(store)
        };
      };
      var controllerActions = {
        clearServiceSuspendResumeModal: clearServiceSuspendResumeModal,
        retrieveBillCycleDetails: retrieveBillCycleDetails,
        retrieveServiceSuspensionQuote: retrieveServiceSuspensionQuote,
        setSelectedServiceIdentifierValues: setSelectedServiceIdentifierValues
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.suspensionTypes = [{
        label: i18n.translate(this.CustomerCareKeys.SERVICE_SUSPENSION_TYPE.NETWORK_ONLY),
        value: SERVICE_SUSPENSION_TYPES.NETWORK
      }, {
        label: i18n.translate(this.CustomerCareKeys.SERVICE_SUSPENSION_TYPE.NETWORK_AND_BILLING),
        value: SERVICE_SUSPENSION_TYPES.NETWORK_AND_BILLING
      }];
      this.model.suspensionType = this.suspensionTypes[0];
      if (this.services.length === 1) {
        this.model.serviceIdentifiers.push(this.services[0].ServiceIdentifier.Value);
        this.actions.setSelectedServiceIdentifierValues(this.model.serviceIdentifiers);
      }
      this.actions.retrieveBillCycleDetails(this.state.currentCustomerBillCycle);
      this.gridSetup();
      this.setSuspensionFees();
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      var _this2 = this;
      if (changesObj.availableProducts && changesObj.availableProducts.currentValue && changesObj.services && changesObj.services.currentValue && changesObj.services.currentValue.length > 1) {
        this.services.forEach(function (service) {
          _this2.availableProducts.find(function (product) {
            return product.Items.find(function (item) {
              return item.LockerItemId === service.ServiceIdentifier.SubscriberProductId && (product.OrderStatus === ORDER_STATUS.OPEN || product.OrderStatus === ORDER_STATUS.PENDING);
            });
          }) ? service.isServiceSuspendable = false : service.isServiceSuspendable = true;
        });
      }
    }
  }, {
    key: "gridSetup",
    value: function gridSetup() {
      var _this3 = this;
      if (this.isActive) {
        this.columnDefs = [{
          field: 'ServiceIdentifier.FormattedValue',
          displayName: i18n.translate(CustomerCareKeys.SERVICE),
          maxWidth: 200,
          minWidth: 150
        }, {
          field: 'ServiceName',
          displayName: i18n.translate(CustomerCareKeys.FRIENDLY_NAME),
          minWidth: 120
        }];
        this.columnDefs.push({
          field: 'oneTimeFee',
          cellTemplate: require('./cellTemplates/fee.cell.template.html'),
          displayName: i18n.translate(CustomerCareKeys.SERVICE_SUSPENSION_FEE.ONE_TIME),
          headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE
        }, {
          field: 'recurringFee',
          cellTemplate: require('./cellTemplates/fee.cell.template.html'),
          displayName: i18n.translate(CustomerCareKeys.SERVICE_SUSPENSION_FEE.RECURRING),
          headerCellTemplate: RIGHT_ALIGNED_HEADER_TEMPLATE
        });
        this.columnDefs.push({
          field: 'DeviceFinancing',
          cellTemplate: require('./cellTemplates/device.finance.cell.template.html'),
          displayName: i18n.translate(CustomerCareKeys.DEVICE_FINANCE_CHARGES),
          minWidth: 220
        });
      }
      if (!this.isActive) {
        this.columnDefs = [{
          headerCellTemplate: '<div></div>',
          field: 'ServiceIdentifier.FormattedValue',
          displayName: i18n.translate(CustomerCareKeys.SERVICE),
          maxWidth: 200,
          minWidth: 150
        }, {
          headerCellTemplate: '<div></div>',
          field: 'ServiceName',
          displayName: i18n.translate(CustomerCareKeys.FRIENDLY_NAME),
          minWidth: 120
        }];
        this.columnDefs.push({
          field: 'SuspendType',
          displayName: i18n.translate(CustomerCareKeys.SUSPENSION_TYPE),
          minWidth: 80
        });
      }
      this.gridData = {
        showHeader: this.isActive,
        enableSelectAll: this.isActive,
        appScopeProvider: this,
        columnDefs: this.columnDefs,
        data: this.services,
        enableSorting: false,
        minRowsToShow: this.services.length + 1,
        isRowSelectable: function isRowSelectable(row) {
          if (!_this3.isActive) {
            if (!_this3.state.hasBillingSuspensionAccess && row.entity.SuspendTypeCode === SERVICE_SUSPENSION_TYPES.NETWORK_AND_BILLING) {
              return false;
            }
            if (!_this3.state.hasFinanceSuspendResumeAccess && row.entity.deviceFinance && row.entity.deviceFinance.status === DEVICE_FINANCE_STATUS.SUSPENDED) {
              return false;
            }
          }
          return row.entity.isServiceSuspendable;
        },
        onRegisterApi: function onRegisterApi(event) {
          _this3.gridApi = event.grid.api;
          _this3.gridApi.selection.clearSelectedRows();
          _this3.gridApi.selection.on.rowSelectionChanged(null, _this3.onRowSelectionChanged);
          _this3.gridApi.selection.on.rowSelectionChangedBatch(null, _this3.onRowSelectionChanged);
        },
        rowTemplate: require('./cellTemplates/checkbox.row.template.html')
      };
    }
  }, {
    key: "onRowSelectionChanged",
    value: function onRowSelectionChanged() {
      var _this4 = this;
      this.selectedItems = this.gridApi.selection.getSelectedRows();
      this.actions.setSelectedServiceIdentifierValues(this.selectedItems.map(function (selectedItem) {
        return selectedItem.ServiceIdentifier.Value;
      }));
      Object.keys(this.model.deviceFinancesDictionary).forEach(function (key) {
        if (!_this4.selectedItems.find(function (item) {
          return path(['deviceFinance', 'serviceIdentifier'], item) === key;
        })) {
          _this4.model.deviceFinancesDictionary[key] = false;
        }
      });
    }
  }, {
    key: "onExecutionOptionChange",
    value: function onExecutionOptionChange(model) {
      this.model.specifiedDate = model.specifiedDate;
    }
  }, {
    key: "doErrorsExistOnFdoForm",
    value: function doErrorsExistOnFdoForm(isFormValid) {
      this.errorsExistOnForm = isFormValid;
    }
  }, {
    key: "getServiceIdentfiers",
    value: function getServiceIdentfiers() {
      if (!(this.services.length === 1)) {
        this.model.serviceIdentifiers = this.selectedItems.map(function (selectedItem) {
          return selectedItem.ServiceIdentifier.Value;
        });
      }
    }
  }, {
    key: "customValidations",
    value: function customValidations() {
      this.formErrorMessages = this.model.serviceIdentifiers.length ? [] : [i18n.translate(CustomerCareKeys.SERVICE_REQUIRED)];
    }
  }, {
    key: "setSubmissionPageFlag",
    value: function setSubmissionPageFlag() {
      var _this5 = this;
      this.confirmationGridData = {
        showHeader: this.isActive,
        appScopeProvider: this,
        columnDefs: this.columnDefs,
        data: this.selectedItems
      };
      this.servicesSuspendResumeForm.$submitted = true;
      this.getServiceIdentfiers();
      this.customValidations();
      this.model.selectedReason = this.reasonCodes.filter(function (reasonCode) {
        return reasonCode.Value === _this5.model.selectedReasonCode;
      });
      if (this.servicesSuspendResumeForm.$valid && !this.formErrorMessages.length) {
        this.onSubmissionPage = true;
      }
    }
  }, {
    key: "onSubmitForm",
    value: function onSubmitForm() {
      var _this6 = this;
      var serviceObj = {};
      serviceObj.ServiceIdentifiers = this.model.serviceIdentifiers
      //add device finances to suspend
      .concat(Object.keys(this.model.deviceFinancesDictionary).reduce(function (deviceFinances, deviceFinanceServiceIdentifierValue) {
        if (_this6.model.deviceFinancesDictionary[deviceFinanceServiceIdentifierValue]) {
          deviceFinances.push(deviceFinanceServiceIdentifierValue);
        }
        return deviceFinances;
      }, []))
      //add device finances to resume;
      .concat(this.model.serviceIdentifiers.reduce(function (deviceFinancesToResume, serviceIdentifierValue) {
        var service = _this6.services.find(function (item) {
          return item.ServiceIdentifier.Value === serviceIdentifierValue;
        });
        var deviceFinance = path(['deviceFinance'], service);
        if (deviceFinance && deviceFinance.status === DEVICE_FINANCE_STATUS.SUSPENDED) {
          deviceFinancesToResume.push(deviceFinance.serviceIdentifier);
        }
        return deviceFinancesToResume;
      }, []));
      serviceObj.Comment = this.model.comment;
      if (this.isActive) {
        serviceObj.SuspensionType = this.model.suspensionType.value;
        serviceObj.SuspendReasonCodeValue = {
          Value: this.model.selectedReasonCode
        };
        serviceObj.SuspensionStartDate = this.model.specifiedDate;
      } else {
        serviceObj.RestoreReasonCodeValue = {
          Value: this.model.selectedReasonCode
        };
        serviceObj.RestorationStartDate = this.model.specifiedDate;
      }
      this.onSubmit()(serviceObj);
    }
  }, {
    key: "title",
    get: function get() {
      if (this.onSubmissionPage && this.services.length > 1) {
        return i18n.translate(this.isActive ? CustomerCareKeys.SERVICE_SUSPEND_SERVICE_COUNT : CustomerCareKeys.SERVICE_RESUME_SERVICE_COUNT, {
          selectedServices: this.selectedItems.length,
          totalServices: this.services.length
        });
      } else {
        return i18n.translate(this.isActive ? CustomerCareKeys.SUSPEND_SERVICE : CustomerCareKeys.RESUME_SERVICE);
      }
    }
  }, {
    key: "confirmationHeading",
    get: function get() {
      return "".concat(this.services[0].ServiceIdentifier.FormattedValue, " ").concat(this.services[0].ServiceName || this.services[0].ServiceIdentifier.FriendlyName || this.EMPTY_STRING);
    }
  }, {
    key: "onSuspensionTypeChange",
    value: function onSuspensionTypeChange() {
      this.model.deviceFinancesDictionary = {};
      this.actions.clearServiceSuspendResumeModal();
      this.setSuspensionFees();
      if (this.model.suspensionType.value === SERVICE_SUSPENSION_TYPES.NETWORK_AND_BILLING) {
        this.onReasonCodeChange();
      }
    }
  }, {
    key: "onReasonCodeChange",
    value: function onReasonCodeChange() {
      var _this7 = this;
      if (this.isActive) {
        if (!this.model.selectedReasonCode) {
          this.actions.clearServiceSuspendResumeModal();
          this.setSuspensionFees();
        } else if (this.model.suspensionType.value === SERVICE_SUSPENSION_TYPES.NETWORK_AND_BILLING) {
          this.actions.retrieveServiceSuspensionQuote(this.model.selectedReasonCode, this.services.map(function (service) {
            return service.ServiceIdentifier.Value;
          })).then(function () {
            _this7.setSuspensionFees();
          }).catch(this.onApiError);
        }
      }
    }
  }, {
    key: "setSuspensionFees",
    value: function setSuspensionFees() {
      var _this8 = this;
      this.services.forEach(function (service) {
        var suspensionFees = _this8.state.servicesSuspensionQuotes[service.ServiceIdentifier.Value];
        service.oneTimeFee = suspensionFees && suspensionFees.oneTimeCharge && suspensionFees.oneTimeCharge.Amount && _this8.$filter('invCurrency')(suspensionFees.oneTimeCharge.Amount, suspensionFees.oneTimeCharge.CurrencyCode);
        service.recurringFee = suspensionFees && suspensionFees.recurringCharge && suspensionFees.recurringCharge.Amount && _this8.$filter('invCurrency')(suspensionFees.recurringCharge.Amount, suspensionFees.recurringCharge.CurrencyCode);
      });
    }
  }, {
    key: "onApiError",
    value: function onApiError(error) {
      this.uiNotificationService.transientError(error.translatedMessage);
    }
  }, {
    key: "showDeviceFinancingNotApplicableLabel",
    value: function showDeviceFinancingNotApplicableLabel(service) {
      if (!service.deviceFinance) {
        return true;
      }
      if (!this.isActive && service.deviceFinance && service.deviceFinance.status !== DEVICE_FINANCE_STATUS.SUSPENDED) {
        return true;
      }
      return false;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearServiceSuspendResumeModal();
      this.disconnectRedux();
    }
  }]);
}();
export default {
  controller: ServicesSuspendResumeController,
  controllerAs: 'ServicesSuspendResume',
  bindings: {
    availableProducts: '<',
    hideFdoOptions: '<?',
    isActive: '<',
    isSuspendingOrResuming: '<',
    onClose: '&',
    onSubmit: '&',
    reasonCodes: '<',
    services: '<'
  },
  template: require('./services.suspend.resume.modal.html')
};